import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <div className="max-w-xl mx-auto px-4 py-24 text-center">
        <div className="w-24 h-24 rounded-full bg-[#E6F4FB] flex items-center justify-center mx-auto mb-6">
          <span className="text-5xl">🔍</span>
        </div>
        <h1 className="text-6xl font-bold text-[#0596DE] mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-[#0F172A] mb-3">
          Page introuvable
        </h2>
        <p className="text-[#64748B] mb-8">
          La page que vous cherchez n'existe pas ou a été déplacée.
        </p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 rounded-full border border-[#E2E8F0] text-[#475569] hover:bg-[#F1F5F9] transition-colors font-medium"
          >
            ← Retour
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 rounded-full bg-[#0596DE] text-white hover:bg-[#047CBA] transition-colors font-medium"
          >
            Accueil
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
